/// <amd-module name="Core/Medius.Core.Web/Scripts/Medius/components/editors/valueOrigin" />

export const Input = "input";
export const Outside = "outside";